export default __webpack_public_path__ + "static/media/nameLogo.931169d7.png";